import intersection from 'lodash/intersection'

import { WithFacetSlug } from 'utils/DirectoryParser'
import { FlexDiv, P } from 'components/generic/HomePageComponents'
import SearchFacet from './SearchFacet'
import FacetDropdown from './FacetDropdown'

function isChecked(selectedFacets, facet) {
  return (
    facet &&
    selectedFacets &&
    (selectedFacets.includes(facet.slug) || selectedFacets.includes(facet.keyword))
  )
}

const Facets = ({ facets, selectedFacets, directoryLinkInformation }) => {
  if (!facets) {
    return null
  }
  return (
    facets &&
    facets.length > 0 &&
    facets.map((facet, i) => {
      if (facet && facet.slugs && facet.slugs.length > 0) {
        const lowercasedSelectedFacets =
          selectedFacets && selectedFacets.map((facet) => facet.toLowerCase())
        const dropdownFacets = facet.slugs.map((facet) => facet.slug.toLowerCase())
        const selectedDropdownFacets = intersection(dropdownFacets, lowercasedSelectedFacets)

        return (
          <FacetDropdown
            key={i}
            facet={facet}
            selectedFacets={selectedDropdownFacets}
            directoryLinkInformation={directoryLinkInformation}
          />
        )
      }
      const newDirectoryLinkInformation = WithFacetSlug(
        directoryLinkInformation,
        facet.keyword || facet.slug
      )
      return (
        <SearchFacet
          key={i}
          type='checkbox'
          checked={isChecked(selectedFacets, facet)}
          facetName={facet.name}
          count={facet.count}
          directoryLinkInformation={newDirectoryLinkInformation}
        />
      )
    })
  )
}

const sumOfFacetCounts = (facets) => {
  if (!facets) {
    return 0
  }
  let sum = 0
  for (const facet of facets) {
    sum += facet.count
  }
  return sum
}

const FacetContainer = ({ facetGroup, selectedFacets, directoryLinkInformation }) => {
  if (!facetGroup || !facetGroup.facets || sumOfFacetCounts(facetGroup.facets) === 0) {
    return null
  }
  return (
    <>
      <FlexDiv justifyContent='space-between'>
        <P lineHeight='20px' fontWeight='bold' fontSize='14px' margin='25px 0px 3px'>
          {facetGroup.name}
        </P>
      </FlexDiv>
      <Facets
        directoryLinkInformation={directoryLinkInformation}
        facets={facetGroup.facets}
        selectedFacets={selectedFacets}
      />
    </>
  )
}

export default FacetContainer
